import { GlBadge, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { issuableTypeText } from '~/issues/constants';
import { __, sprintf } from '~/locale';
export default {
    name: 'ArchivedBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        issuableType: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        title () {
            return sprintf(__('This %{issuable} belongs to an archived project and is read-only.'), {
                issuable: issuableTypeText[this.issuableType] || this.issuableType || 'item'
            });
        }
    }
};
